import('../../../sbf-design-system/components/forms/email_suggest.js').then(({default: initEmailFields}) => initEmailFields('#email'));

$(function () {
  function removeErrorLabel () {
    $(this).unbind('change', removeErrorLabel).closest('label').removeClass('error');
  }

  $('label.error input, label.error select, label.error textarea').bind('change', removeErrorLabel);
});
